import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
    FlyFreelyError,
    FlyFreelyLoggingService,
    LocationDetailsDto,
    Lotam,
    MissionNoticeAcknowledgementDto,
    MissionNoticeDto,
    Organisation,
    WorkTracker
} from '@flyfreely-portal-ui/flyfreely';
import { MissionNoticesDataService } from '@flyfreely-portal-ui/notices-shared';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'mission-lotam-details',
    templateUrl: './mission-lotam-details.component.html',
    styleUrls: ['./mission-lotam-details.component.scss']
})
export class MissionLotamDetailsComponent {
    @Input() lotam: Lotam;
    @Input() organisation: Organisation;
    @Input() missionId: number;
    @Input() missionLocation: LocationDetailsDto;
    @Input() isReadOnly = false;
    @Input() isAcknowledgedInMission = false;
    @Input() status: MissionNoticeDto.Status;
    @Output() acknowledge = new EventEmitter<MissionNoticeAcknowledgementDto>();

    private workTracker = new WorkTracker();
    working = false;
    private ngUnsubscribe$ = new Subject<void>();

    constructor(
        private modal: BsModalRef<MissionLotamDetailsComponent>,
        private lotamDataService: MissionNoticesDataService,
        private logging: FlyFreelyLoggingService
    ) {}

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    onCancel() {
        this.modal.hide();
    }

    onAcknowledgeForMission() {
        this.lotamDataService
            .acknowledgeMissionLotam(this.missionId, this.lotam.id)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: result => {
                    this.isAcknowledgedInMission = true;
                    this.acknowledge.emit(result);
                    this.logging.success(
                        `Successfully acknowledge LOTAM ${this.lotam.subject}`
                    );
                    this.modal.hide();
                },
                error: (error: FlyFreelyError) => {
                    this.logging.error(
                        error,
                        `Error while acknowledge LOTAM: ${error.message}`
                    );
                }
            })
            .add(this.workTracker.createTracker());
    }
}
